export default __webpack_public_path__ + "static/media/IMG_9963.c64c6a0e.jpg";